import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import { AuditCatalogueProvider } from './context/AuditCatalogueContext';
import './index.css';
import './styles/orders.css';
import './styles/offers.css';
import './styles/audit.css';
import './styles/marketing.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FeatureFlagsProvider>
          <AuditCatalogueProvider>
            <App />
          </AuditCatalogueProvider>
        </FeatureFlagsProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
